/* eslint-disable no-console */
/* eslint-disable arrow-body-style */
import { useState, useEffect } from "react";

const getLocalStorage = (): Storage => window.localStorage;
export const setLocalValue = (key: string, value: string): void => {
    getLocalStorage().setItem(key, value);
};
export const getLocalValue = (key: string): string | null => {
    return getLocalStorage().getItem(key);
};
export const removeLocalValue = (key: string): void => {
    getLocalStorage().removeItem(key);
};

const getSessionStorage = (): Storage => window.sessionStorage;
export const setSessionValue = (key: string, value: string): void => {
    getSessionStorage().setItem(key, value);
};
export const getSessionValue = (key: string): string => {
    return getSessionStorage().getItem(key) || "";
};
export const removeSessionValue = (key: string): void => {
    getSessionStorage().removeItem(key);
};

// useStateとuseEffectを使用し、localStorageを扱うためのフックを定義
export const useLocalStorage = (key: string, initialValue: string) => {
    const [storedValue, setStoredValue] = useState(() => {
        try {
            // localStorageから値を取得。値が存在しない場合はinitialValueを返す
            return getLocalValue(key) || initialValue;
        } catch (error) {
            console.log(error);
            return initialValue;
        }
    });

    // useEffectを使用し、stateの値が変更された時にlocalStorageに値を保存
    useEffect(() => {
        try {
            setLocalValue(key, storedValue);
        } catch (error) {
            console.log(error);
        }
    }, [key, storedValue]);

    return [storedValue, setStoredValue];
};
